import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "rd-head" }
const _hoisted_2 = { class: "rd-company" }
const _hoisted_3 = {
  key: 0,
  class: "rd-empty"
}
const _hoisted_4 = {
  key: 1,
  class: "rd-body"
}
const _hoisted_5 = { class: "rd-col rd-col-roluri" }
const _hoisted_6 = { class: "rd-col-head" }
const _hoisted_7 = { class: "row-actions" }
const _hoisted_8 = { class: "rd-col rd-col-drepturi" }
const _hoisted_9 = { class: "rd-col-head" }
const _hoisted_10 = { class: "rd-tabs" }
const _hoisted_11 = {
  key: 0,
  class: "rd-empty rd-empty-inline"
}
const _hoisted_12 = ["checked", "onChange"]
const _hoisted_13 = ["checked", "onChange"]
const _hoisted_14 = { class: "rol-form" }
const _hoisted_15 = { class: "ff-actions" }
const _hoisted_16 = { class: "del-body" }
const _hoisted_17 = { class: "ff-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "rd-title" }, "Roluri & drepturi", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DxSelectBox, {
            "data-source": _ctx.companii,
            "value-expr": "ID",
            "display-expr": "Name",
            placeholder: "Selectați firma...",
            width: "280",
            value: _ctx.selectedCompanyId,
            onValueChanged: _ctx.onCompanyChanged
          }, null, 8, ["data-source", "value", "onValueChanged"])
        ])
      ]),
      _createVNode(_component_v_divider, { class: "my-3" }),
      (!_ctx.selectedCompanyId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Selectați o firmă pentru a gestiona rolurile și drepturile. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "Roluri", -1)),
                _createVNode(_component_DxButton, {
                  icon: "add",
                  text: "Rol nou",
                  "styling-mode": "text",
                  onClick: _ctx.openAddRol
                }, null, 8, ["onClick"])
              ]),
              _createVNode(_component_DxDataGrid, {
                "data-source": _ctx.roluri,
                "key-expr": "ID",
                "show-borders": true,
                "show-column-lines": false,
                "show-row-lines": true,
                "row-alternation-enabled": true,
                "hover-state-enabled": true,
                "column-auto-width": true,
                height: "calc(100vh - 320px)",
                "selected-row-keys": _ctx.selectedRolKeys,
                onSelectionChanged: _ctx.onSelectionChanged
              }, {
                rolActions: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_DxButton, {
                      icon: "edit",
                      "styling-mode": "text",
                      onClick: ($event: any) => (_ctx.openEditRol(data.data))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_DxButton, {
                      icon: "trash",
                      "styling-mode": "text",
                      onClick: ($event: any) => (_ctx.confirmDeleteRol(data.data))
                    }, null, 8, ["onClick"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxSelection, { mode: "single" }),
                  _createVNode(_component_DxSearchPanel, {
                    visible: true,
                    placeholder: "Caută rol..."
                  }),
                  _createVNode(_component_DxPaging, { "page-size": 20 }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Cod",
                    caption: "Cod",
                    width: 120
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Nume",
                    caption: "Nume"
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Explicatie",
                    caption: "Explicație"
                  }),
                  _createVNode(_component_DxColumn, {
                    caption: "",
                    width: 90,
                    "cell-template": "rolActions"
                  })
                ]),
                _: 1
              }, 8, ["data-source", "selected-row-keys", "onSelectionChanged"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["rd-tab-btn", { 'rd-tab-active': _ctx.dreapraTab === 'drepturi' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dreapraTab = 'drepturi'))
                  }, "Drepturi", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["rd-tab-btn", { 'rd-tab-active': _ctx.dreapraTab === 'utilizatori' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dreapraTab = 'utilizatori'))
                  }, "Utilizatori", 2)
                ]),
                (_ctx.rolSelectat && _ctx.dreapraTab === 'drepturi')
                  ? (_openBlock(), _createBlock(_component_DxButton, {
                      key: 0,
                      text: "Salvează drepturile",
                      "styling-mode": "contained",
                      type: "default",
                      disabled: !_ctx.hasChanges,
                      onClick: _ctx.saveDrepturi
                    }, null, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.rolSelectat)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Selectați un rol din stânga pentru a-i vedea/edita drepturile. "))
                : (_ctx.dreapraTab === 'drepturi')
                  ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                      key: 1,
                      "data-source": _ctx.drepturiRol,
                      "key-expr": "ID",
                      "show-borders": true,
                      "show-column-lines": false,
                      "show-row-lines": true,
                      "row-alternation-enabled": true,
                      "hover-state-enabled": true,
                      "column-auto-width": true,
                      height: "calc(100vh - 320px)"
                    }, {
                      alocatCell: _withCtx(({ data }) => [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: data.data.HasRight,
                          onChange: ($event: any) => (_ctx.toggleDrept(data.data, ($event.target as HTMLInputElement).checked))
                        }, null, 40, _hoisted_12)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Caută drept..."
                        }),
                        _createVNode(_component_DxPaging, { "page-size": 50 }),
                        _createVNode(_component_DxColumn, {
                          "data-field": "Nume",
                          caption: "Denumire"
                        }),
                        _createVNode(_component_DxColumn, {
                          "data-field": "Cod",
                          caption: "Cod",
                          width: 180
                        }),
                        _createVNode(_component_DxColumn, {
                          caption: "Alocat",
                          width: 90,
                          alignment: "center",
                          "cell-template": "alocatCell"
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source"]))
                  : (_openBlock(), _createBlock(_component_DxDataGrid, {
                      key: 2,
                      "data-source": _ctx.utilizatoriFirma,
                      "key-expr": "ID",
                      "show-borders": true,
                      "show-column-lines": false,
                      "show-row-lines": true,
                      "row-alternation-enabled": true,
                      "hover-state-enabled": true,
                      "column-auto-width": true,
                      height: "calc(100vh - 320px)"
                    }, {
                      alocatUserCell: _withCtx(({ data }) => [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.isUserAlocat(data.data.ID),
                          onChange: ($event: any) => (_ctx.toggleUtilizator(data.data, ($event.target as HTMLInputElement).checked))
                        }, null, 40, _hoisted_13)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Caută utilizator..."
                        }),
                        _createVNode(_component_DxPaging, { "page-size": 50 }),
                        _createVNode(_component_DxColumn, {
                          "data-field": "Username",
                          caption: "Utilizator"
                        }),
                        _createVNode(_component_DxColumn, {
                          "data-field": "Email",
                          caption: "Email"
                        }),
                        _createVNode(_component_DxColumn, {
                          caption: "Alocat",
                          width: 90,
                          alignment: "center",
                          "cell-template": "alocatUserCell"
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source"]))
            ])
          ])),
      _createVNode(_component_DxPopup, {
        visible: _ctx.rolPopupVisible,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rolPopupVisible) = $event)),
        title: _ctx.rolEditMode ? 'Editare rol' : 'Rol nou',
        width: 440,
        height: "auto",
        "drag-enabled": false,
        "wrapper-attr": { class: 'era-edit-popup' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _cache[12] || (_cache[12] = _createElementVNode("label", null, "Cod", -1)),
            _createVNode(_component_DxTextBox, {
              value: _ctx.rolForm.Cod,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rolForm.Cod) = $event)),
              placeholder: "Cod rol"
            }, null, 8, ["value"]),
            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Nume", -1)),
            _createVNode(_component_DxTextBox, {
              value: _ctx.rolForm.Nume,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rolForm.Nume) = $event)),
              placeholder: "Nume rol"
            }, null, 8, ["value"]),
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Explicație", -1)),
            _createVNode(_component_DxTextArea, {
              value: _ctx.rolForm.Explicatie,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rolForm.Explicatie) = $event)),
              placeholder: "Explicație (opțional)",
              height: 80
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_15, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ff-spacer" }, null, -1)),
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "default",
                "styling-mode": "contained",
                onClick: _ctx.saveRol
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                "styling-mode": "outlined",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.rolPopupVisible = false))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.deleteRolVisible,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.deleteRolVisible) = $event)),
        title: "Ștergere rol",
        width: 420,
        height: "auto",
        "drag-enabled": false,
        "wrapper-attr": { class: 'era-edit-popup' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", null, [
              _cache[15] || (_cache[15] = _createTextVNode("Sigur vrei să ștergi rolul ", -1)),
              _createElementVNode("strong", null, "„" + _toDisplayString(_ctx.toDeleteRol && _ctx.toDeleteRol.Nume) + "\"", 1),
              _cache[16] || (_cache[16] = _createTextVNode("?", -1))
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "del-warn" }, "Toate drepturile asociate acestui rol vor deveni indisponibile.", -1)),
            _createElementVNode("div", _hoisted_17, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ff-spacer" }, null, -1)),
              _createVNode(_component_DxButton, {
                text: "Șterge",
                type: "danger",
                "styling-mode": "contained",
                onClick: _ctx.doDeleteRol
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                "styling-mode": "outlined",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteRolVisible = false))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}